import { useEffect, useState } from "react";
import { MdOutlineKeyboardDoubleArrowLeft, MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import EventCard from "./eventCard";
import PropTypes from 'prop-types';
import { retrunAssets } from "../../../utils/getAssets";
import { DecodeHtml } from "../../../utils/decodeHtml";
import { apis } from "../../../api/apiUrl";

const Event = ({ articles }) => {
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const itemsToShow = 3;
    const paginationWindow = 5; // Show only 5 page numbers at a time

    useEffect(() => {
        setData([]);
        const fetchData = async (path) => {
            try {
                const response = await fetch(`${apis.umbraco_delivery_api}/${path}?expand=properties%5B%24all%5D&fields=properties%5B%24all%5D`);
                const data = await response.json();
                setData(prev => [
                    ...prev,
                    {
                        title: data?.properties?.title,
                        children: DecodeHtml({ html: data?.properties?.richTextContent?.markup }),
                        img: data?.properties?.thumbnailImage?.[0]?.url ? retrunAssets(data.properties.thumbnailImage[0].url) : "",
                        date: data?.properties?.publishedDate,
                    }
                ]);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        articles?.forEach(item => {
            fetchData(item.link);
        });
    }, [articles]);

    const totalPages = Math.ceil(data.length / itemsToShow);

    const handlePrevClick = () => {
        if (currentPage > 0) {
            setCurrentPage(prev => prev - 1);
        }
    };

    const handleNextClick = () => {
        if (currentPage < totalPages - 1) {
            setCurrentPage(prev => prev + 1);
        }
    };

    const handlePageClick = (page) => {
        setCurrentPage(page);
    };

    const currentData = data.slice(currentPage * itemsToShow, (currentPage + 1) * itemsToShow);

    // Pagination logic: create a sliding window for page numbers
    const startPage = Math.floor(currentPage / paginationWindow) * paginationWindow;
    const endPage = Math.min(startPage + paginationWindow, totalPages);

    return (
        <div className="grid gap-10">
            <h1 className="text-2xl font-bold  text-[#081330]">Events</h1>
            <div className="flex flex-col gap-8 w-full">
                {currentData.map((article, index) => (
                    <EventCard event={article} key={index} />
                ))}
            </div>

            {totalPages > 1 && (
                <div className="flex items-center gap-3 cursor-pointer select-none">
                    <MdOutlineKeyboardDoubleArrowLeft
                        size={25}
                        onClick={handlePrevClick}
                        className={currentPage === 0 ? 'opacity-50 cursor-not-allowed' : ''}
                    />
                    {[...Array(endPage - startPage).keys()].map(pageOffset => {
                        const page = startPage + pageOffset;
                        return (
                            <span
                                key={page}
                                className={`text-cyan-400 text-lg hover:text-cyan-600 transition-all p-2 rounded ${page === currentPage ? 'bg-cyan-400 text-neutral-700' : ''}`}
                                onClick={() => handlePageClick(page)}
                            >
                                {page + 1}
                            </span>
                        );
                    })}
                    <MdOutlineKeyboardDoubleArrowRight
                        size={25}
                        onClick={handleNextClick}
                        className={currentPage === totalPages - 1 ? 'opacity-50 cursor-not-allowed' : ''}
                    />
                </div>
            )}
        </div>
    );
};

Event.propTypes = {
    articles: PropTypes.any
};

export default Event;
